import { useParams } from 'react-router-dom';
import { parseRouteParams } from 'ziphy-web-shared/basic/utils/router';
export const useParsedParams = () => {
    const routerParams = useParams();
    return parseRouteParams(routerParams);
};
